import React from 'react';
import { bool, shape, string } from 'prop-types';

const FilterListColor = ({
  className = '',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.25 4.5V6H15.75V4.5H2.25ZM7.5 13.5H10.5V12H7.5V13.5ZM13.5 9.75H4.5V8.25H13.5V9.75Z" fill="currentColor" />

  </svg>
);

FilterListColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default FilterListColor;
